var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"all"},[_c('v-main',{staticClass:"homepage"},[_c('Nav'),_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }